$(document).ready(function ($) {
 
  /*PDP checking fetured block have data or not
  var pdpFeatured = false;
  $("#features  .halfSection").each(function () {
    if ($(this).html().trim() != "") {
      if ($(this).children("ul").html() != undefined) {
        if ($(this).children("ul").html().trim() != "") {
          pdpFeatured = true;
        }
      } else {
        pdpFeatured = true;
      }
    }
  });
  if (pdpFeatured == false) {
    $(".js-features-tab").removeClass("active");
    $(".js-features-tab").children("a").removeClass("is-active");
    $(".js-reviews-tab").addClass("active");
    $(".js-reviews-tab").children("a").addClass("is-active");
    $(".tab-switch__content").addClass("is-hidden");
    $("#reviews").removeClass("is-hidden");
  } */

  /*Collection Filter mobile click*/
  $(".pt-nav-toggle").click(function (e) {
    if ($(this).hasClass("active")) {
      $(".has_group_selected").removeClass("active");
    } else {
      $(".has_group_selected").addClass("active");
    }
  });

  /* Load Carousels */
  /* Logos */
  $(".component-logo-list-ul").owlCarousel({
    loop: true,
    stagePadding: 60,
    margin: 0,
    nav: true,
    mouseDrag: false,
    touchDrag: true,
    dots: false,
    autoplay: false,
    autoHeight: true,
    items: 5,
    autoplayTimeout: 5000,
    responsive: {
      0: {
        items: 2,
        margin: 20,
        stagePadding: 35,
      },
      481: {
        items: 2,
        stagePadding: 35,
        margin: 40,
      },
      600: {
        items: 3,
        stagePadding: 35,
        margin: 15,
      },
      981: {
        items: 4,
      },
      1200: {
        items: 5,
      },
    },
  });
  /* Products */
  if (window.innerWidth > 980) {
   $(".component-carousel-ul").owlCarousel({
    loop: true,
    stagePadding: 50,
    margin: 60,
    nav: true,
    mouseDrag: false,
    touchDrag: true,
    dots: false,
    autoplay: false,
    autoHeight: true,
    items: 5,
    autoplayTimeout: 5000,
    responsive: {
      0: {
        items: 2,
        margin: 20,
        stagePadding: 0,
      },
      481: {
        items: 2,
        stagePadding: 27,
        margin: 40,
      },
      600: {
        items: 2,
        stagePadding: 27,
        margin: 40,
      },
      981: {
        items: 4,
      },
      1200: {
        items: 5,
      },
    },
  }); 
  }
  
  var heroSliderSpeed=parseInt($("#js-slider-timer").val());
  heroSliderSpeed=heroSliderSpeed*1000;
  /* Hero Slider */
  $(".component-hero-banner-ul").owlCarousel({
    loop: true,
    stagePadding: 0,
    margin: 0,
    nav: false,
    mouseDrag: false,
    touchDrag: true,
    dots: true,
    autoplay: true,
    autoHeight: true,
    items: 1,
    autoplayTimeout: heroSliderSpeed
    
  });
  $(".beforeAfter-carousel-ul").owlCarousel({
    loop: true,
    stagePadding: 0,
    margin: 0,
    nav: true,
    mouseDrag: false,
    touchDrag: true,
    dots: true,
    autoplay: false,
    autoHeight: true,
    items: 1,
    autoplayTimeout: 5000,
  });
  /* Products */
  $(".four-block-with-image-ul").owlCarousel({
    loop: true,
    stagePadding: 60,
    margin: 12,
    nav: true,
    mouseDrag: false,
    touchDrag: true,
    dots: false,
    autoplay: false,
    autoHeight: true,
    items: 4,
    autoplayTimeout: 5000,
    responsive: {
      0: {
        items: 1,
        margin: 20,
        stagePadding: 0,
      },
      401: {
        items: 2,
        margin: 20,
        stagePadding: 0,
      },
      481: {
        items: 2,
        stagePadding: 27,
        margin: 40,
      },
      769: {
        items: 3,
        stagePadding: 27,
        margin: 40,
      },
      981: {
        items: 4,
      },
      1200: {
        items: 4,
      },
    },
  });
  /* Accordion working on the jobs page */
  $(".js-accordion h4").click(function (e) {
    if ($(this).parent("li").children("p").css("display") == "none") {
      $(".needHelpAccordian li").removeClass("active");
      $(".needHelpAccordian li").children("p").slideUp();
      $(this).parent("li").children("p").slideDown();
      $(this).parent("li").addClass("active");
    } else {
      $(this).parent("li").children("p").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });
  $(".productThumb").click(function (e) {
    var ID = $(this).attr("id").replace("productThumb", "");
    $(".productThumb").removeClass("active");
    $(".productImage").removeClass("active");
    $("#productImage" + ID).addClass("active");
    $(this).addClass("active");
  });
  /* Tagging Click for collections and stories page */
  $("#article-categary-mobile").click(function (e) {
    if ($(".leftSidebar ul").css("display") == "none") {
      $(".leftSidebar ul").slideDown();
      $(this).addClass("active");
    } else {
      $(".leftSidebar ul").slideUp();
      $(this).removeClass("active");
    }
  });
  $(".sub-has-child").click(function (e) {
    if ($(this).children("ul").css("display") == "none") {
      $(this).children("ul").slideDown();
      $(this).addClass("active");
    } else {
      $(this).children("ul").slideUp();
      $(this).removeClass("active");
    }
  });
  $(".has-child").click(function (e) {
    $(this).children(".submenu-child-outer").show();
    $(".contact-section").hide();
    $(".socail-section").hide();
  });
  $(".back-button").click(function (e) {
    e.stopPropagation();
    $(this).parent(".submenu-child-outer").hide();
    $(".contact-section").show();
    $(".socail-section").show();
  });
  $(".mobile-nav").click(function (e) {
    if ($(this).hasClass("active")) {
      $(".mobile-menu").removeClass("active");
      $(".mobile-menu-bg").removeClass("active");
      $("body").removeClass("fixed-body");
      $(this).removeClass("active");
    } else {
      $(".mobile-menu").addClass("active");
      $(".mobile-menu-bg").addClass("active");
      $("body").addClass("fixed-body");
      $(this).addClass("active");
    }
  });
  $(window).resize(function () {
    if ($(window).width() > 980) {
      $(".mobile-menu").removeClass("active");
      $(".mobile-menu-bg").removeClass("active");
      $(".mobile-nav").removeClass("active");
      $("body").removeClass("fixed-body");
    }
  });
  if (window.location.href.indexOf("tagged") > -1) {
    var tagValue = window.location.href.split("/")[6];
    $("#article-categary-mobile").html(tagValue);
  } else {
    $("#article-categary-mobile").html("All Articles");
    $(".allarticle").addClass("active");
  }
  var firstTitle = $(".component-tabs-square-list ul")
    .children("li:first-child")
    .children("h5")
    .html();
  $(".component-tabs-square-section")
    .children(".component-inner:first-child")
    .children("h2")
    .html(firstTitle);
  $(".component-tabs-square-list ul")
    .children("li:first-child")
    .addClass("active");
  $(".component-tabs-square-section")
    .children(".component-inner:first-child")
    .addClass("active");
  $(".component-tabs-square-list li").click(function (e) {
    var index = $(this).index() + 1;
    var title = $(this).children("h5").html();
    $(".component-tabs-square-list ul").children("li").removeClass("active");
    $(this).addClass("active");
    $(".component-tabs-square-section")
      .children(".component-inner:nth-child(" + index + ")")
      .children("h2")
      .html(title);
    $(".component-tabs-square-section")
      .children(".component-inner")
      .removeClass("active");
    $(".component-tabs-square-section")
      .children(".component-inner:nth-child(" + index + ")")
      .addClass("active");
  });
  $(".js-custom-kitchen-hero-btn").click(function (e) {
    var pos = $("#cutsom-kitchen-form-section").offset().top - 150;
    jQuery("body, html").animate({
      scrollTop: pos,
    });
  });
});
$(".tab-switch__trigger").click(function (e) {
  var windowsize = $(window).width();
  if (windowsize < 769) {
    $(".tab-switch__nav-outer").slideUp();
  }
  $("#product-tab-selected").html($(this).html());
  $("#product-tab-selected").removeClass("active");
  $(".tab-switch__nav").children("li").removeClass("active");
  $(this).parent("li").addClass("active");
});
$("#product-tab-selected").click(function (e) {
  if ($(".tab-switch__nav-outer").css("display") == "none") {
    $(".tab-switch__nav-outer").slideDown();
    $(this).addClass("active");
  } else {
    $(".tab-switch__nav-outer").slideUp();
    $(this).removeClass("active");
  }
});
$(window).scroll(function (event) {
  var scroll = $(window).scrollTop();
  jQuery(".howItWorkSection  .howItWorkContent").each(function () {
    var position = $(this).offset().top - 500;
    if (scroll >= position) {
      // alert('if');
      $(this).addClass("visibleLight");
    }
  });
});
